export default __webpack_public_path__ + "static/media/book.3cc6bea0.png";